<template>
  <div id="answers">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>All User Answers</h1>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
          <v-col cols="3" sm="4" md="3">
          
           <v-card-title>
           <v-select class="difficulty"   v-model="searchingType" hide-details :items="searchType" ></v-select> 
           </v-card-title>
          
          </v-col>
        <v-col cols="6" sm="4" md="6">
          
           <v-card-title>
            <v-text-field
              v-model="search"
              label="Search Text"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          
          </v-col>
          <v-col cols="6" sm="4" md="3">
          
           <v-card-title>
            <v-btn color="primary text-center" @click.prevent="searchdata">Search</v-btn>
          </v-card-title>
          
          </v-col>
      </v-row>
      <v-row align="center" justify="center">
      
          <v-card>
          <v-data-table
            :headers="headers"
            :items="transactions"
            
            
             hide-default-footer  
             disable-pagination
          >
          <template v-slot:item="{ item }"  >
            <tr>
              <td>
                <h4>{{ item.created_at | moment('timezone', timezone, " h:mm:ss a") }}</h4>
              {{ item.created_at | moment('timezone', timezone, " Do MMMM YYYY") }}
              </td>
              <td><span v-if="item.speed !== null">{{item.speed}}s</span></td>
              <td>
                 {{ item.name }}
               </td>
              <td>{{ item.user.email}}</td>
              <td>{{ item.user.region}}</td>
              <td>{{ item.question_id}}</td>
              <td>{{ item.question.question}}</td>
              <td ><span :class="{ 'correct':  item.correct_answer == 'A', 'incorrect': !item.answered_correctly && item.correct_answer == 'A', 'incorrect': !item.answered_correctly && item.given_answer == 'a'}">{{item.question.option_a}}</span></td> 
            <td ><span :class="{ 'correct':  item.correct_answer == 'B', 'incorrect': !item.answered_correctly && item.correct_answer == 'B', 'incorrect': !item.answered_correctly && item.given_answer == 'b'}">{{item.question.option_b}}</span></td> 
            <td ><span :class="{ 'correct':  item.correct_answer == 'C', 'incorrect': !item.answered_correctly && item.correct_answer == 'C', 'incorrect': !item.answered_correctly && item.given_answer == 'c'}">{{item.question.option_c}}</span></td> 
            <td ><span :class="{ 'correct':  item.correct_answer == 'D', 'incorrect': !item.answered_correctly && item.correct_answer == 'D', 'incorrect': !item.answered_correctly && item.given_answer == 'd'}">{{item.question.option_d}}</span></td> 
             <td>{{ item.question.difficulty  }}</td>
            </tr>
             
            <!-- <template v-slot:item.amount="{ item }">${{ (item.amount/100).toFixed(2) }}</template>
            <template v-slot:item.balance="{ item }">${{ (item.balance/100).toFixed(2) }}</template>  -->
            
             </template>   
          </v-data-table>
           <infinite-loading  :identifier="infiniteId" @infinite="getList"></infinite-loading>
        </v-card>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "GameTransactions",
  data() {
    return {
      search: "",
      searchingType:"",
          page:1,
      transactions: [],
      headers: [
        { text: "Date", value: "created_at", align: "start" },
        { text: "Speed", value: "speed"},
        { text: "Name", value: "name" },
        { text: "Email", value: "user.email" },
        { text: "Region", value: "user.region" },
        { text: "Question Id", value: "question_id" },
        { text: "Question", value: "question.question" },
        { text: "A", value: "question.option_a" },
        { text: "B", value: "question.option_b" },
        { text: "C", value: "question.option_c" },
        { text: "D", value: "question.option_d" },
        { text: "Difficulty", value: "question.difficulty" },
      ],
      searchType:["By Email","By Name","Question"],
      infiniteId: +new Date(),


    };
  },
  mounted() {
   // this.getGameTransactions();
    this.getTimezone();
  },
  computed: {},
  methods: {
    getGameTransactions() {
      var parameter = "page="+this.page;
      if (this.transactions == "undefined" || this.transactions.length < 1) {
        this.$store.dispatch("retrieveAdminGameTransactions",{paramters:parameter}).then(() => {
          this.transactions = this.$store.getters.adminGameTransactions;
        });
      }
    },
   searchdata(){
      this.infiniteId += 1;
       this.page = 1;
       this.getList();
       this.transactions = [];
   }, 
   getList($state)
    {
       var parameter = "page="+ this.page;
         
        if(this.search!='')
         {
           if(this.searchingType=='By Email')
             {parameter += "&email="+this.search;}
           else if(this.searchingType=='By Name')
             {parameter += "&name="+this.search;}
          else if(this.searchingType=='Question')
             {parameter += "&question="+this.search;}     
           
         }
       
       this.$store.dispatch("retrieveAdminGameTransactions",{paramters:parameter}).then((response) => {
          if(response.data.length)
          {
             this.page += 1;
             this.transactions.push(...response.data);
             $state.loaded();
          }
          else
          {
            
            $state.complete();
          }
       });
     },
    getTimezone() {
      this.timezone = this.$moment.tz.guess();
    }
  }
};
</script>

<style scoped>
.container.fill-height > .row {
  max-width: initial;
}

.correct {
  color: green;
  display: block;
}

.incorrect {
  color: red;
  display: block;
}
</style>